const swiperForm_Reviews = new Swiper('.form__reviews', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    speed: 800,
    watchSlidesProgress: true,
    effect: 'fade',
    autoHeight: true,
    pagination: {
      el: ".form__reviews-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 4000, 
      disableOnInteraction: false,
    },
});


const fileInput = document.getElementById("fileInput");
if (fileInput) {
  const fileName = document.getElementById("fileName");

  fileInput.addEventListener("change", () => {
    const file = fileInput.files[0];
    fileName.textContent = file ? file.name : "";
    document.querySelector('.upload-label').classList.add('active')
  });
}
